import { Logger } from '~/helpers/logger';
import { Cart } from '~/modules/GraphQL/types';
import { VsfContext } from '~/composables/context';

export const applyCouponCommand = {
  execute: async (context: VsfContext, {
    currentCart,
    couponCode,
    customQuery = { applyCouponToCart: 'applyCouponToCart' },
    customHeaders = {},
  }) => {
    Logger.debug('[Magento]: Apply coupon on cart', {
      couponCode,
      currentCart,
    });

    const response = await context.$magento.api.customMutation({
      mutation: customQuery.applyCouponToCart, mutationVariables: {input: {
        cart_id: currentCart.id,
        coupon_code: couponCode ? String(couponCode).toUpperCase() : null,
      }}, customHeaders
    });

    const { data, errors } = response;
    Logger.debug('[Result]:', { data, errors });
    return {
      // @ts-ignore
      updatedCart: {...data.applyCouponToCart?.cart, ...(currentCart.raw_id ?{raw_id: currentCart.raw_id}:{})} as unknown as Cart,
      updatedCoupon: { code: couponCode },
      errors,
    };
  },
};